import React from 'react';

const TermsAndConditionsPage = () => {
  return (
    <div className="mx-5 md:mx-40 mt-10 mb-20">
      <h2 className="text-2xl font-bold mb-4">Terms and Conditions</h2>
      <p>By accessing and using the website, users agree to comply with the terms and conditions outlined below. They acknowledge that any violation of these terms may result in account suspension or termination.</p>

      <h3 className="text-xl font-bold mt-6">User Responsibilities</h3>
      <p>Users are responsible for the accuracy and legality of the information they provide, including item listings, pricing, and contact details. They must ensure that all transactions are conducted in good faith and comply with applicable laws and regulations.</p>

      <h3 className="text-xl font-bold mt-6">Item Listings and Descriptions</h3>
      <p>Sellers must accurately describe their items for sale, including condition, specifications, and any defects or limitations. Any misrepresentation or fraudulent activity is strictly prohibited.</p>

      <h3 className="text-xl font-bold mt-6">Buyer-Seller Communication</h3>
      <p>The website provides a platform for communication between buyers and sellers. Users must engage in respectful and professional communication, refraining from any form of harassment, discrimination, or offensive behavior.</p>

      <h3 className="text-xl font-bold mt-6">Transactions and Payments</h3>
      <p>Users agree to complete transactions promptly and in good faith. Buyers must submit payment for purchased items, while sellers must promptly deliver items upon receiving payment. The website may offer payment processing services, and users must comply with any applicable terms related to payment processing.</p>

      <h3 className="text-xl font-bold mt-6">Dispute Resolution</h3>
      <p>In the event of a dispute between buyers and sellers, users agree to engage in good faith negotiations to resolve the issue. The website may provide dispute resolution mechanisms or guidelines to assist in resolving conflicts.</p>

      <h3 className="text-xl font-bold mt-6">Liability and Indemnification</h3>
      <p>The website and its operators are not responsible for any direct or indirect damages or losses incurred through the use of the platform. Users agree to indemnify and hold the website and its operators harmless from any claims, liabilities, or expenses arising from their use of the platform.</p>
    </div>
  );
};

export default TermsAndConditionsPage;
